import { useEffect, useState } from "react";
import { PaymentMethod } from "../../../../../../api/tournament-participant";
import { useRecoilValue } from "recoil";
import { pubState } from "../../../../../../recoil/pub.atom";
import { PayTypeContent, PayTypeItem, PayTypeWrapper } from "./style";
import { Const } from "../../../../../../common/const/const";
import { WideState } from "../../../../../../recoil/wide";
import {
  exchangePoint,
  exchangePointToWon,
  exchangeSeed,
} from "../../../../../../utils/number";

export interface PayTypeDto {
  name: string;
  type: PaymentMethod;
  value: number;
  set: (value: number) => void;
  prev: React.MutableRefObject<number | null>;
  unit?: string;
}

interface PaymentTypeInputProps {
  payType: PayTypeDto[];
  buyIn: number | undefined;
  setTotalPay: (value: number) => void;
  setPayPoint?: (value: number) => void;
  setPaySeed?: (value: number) => void;
  totalPay: number;
  addStack?: number;
  setAddStack?: (value: number) => void;
  handleBuyIn?: () => void;
  handlePayFull?: (index: number) => void;
}

export const PaymentTypeInput = ({
  payType,
  buyIn,
  setTotalPay,
  setPayPoint,
  setPaySeed,
  totalPay,
  addStack,
  setAddStack,
  handleBuyIn,
  handlePayFull,
}: PaymentTypeInputProps) => {
  const [hover, setHover] = useState(-1);
  const isWide = useRecoilValue(WideState);
  const pub = useRecoilValue(pubState);
  const formatNumber = (num: number) => {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const handleTotalPay = () => {
    if (!buyIn) return;
    let sum = 0;
    payType.forEach((value) => {
      sum += value.value ? value.value : 0;
    });

    setTotalPay(buyIn - sum);
  };

  useEffect(() => {
    handleTotalPay();
  });

  const getPaymentText = () => {
    if (!pub) return "";
    const text = `${totalPay?.toLocaleString()}원`;
    const seed = `${exchangeSeed(totalPay)}RABBIT`;
    const point = `${exchangePoint(totalPay)}E`;
    return `${text} / ${seed} / ${point}`;
  };

  const handlePayAmount = (value: string, item: PayTypeDto) => {
    const rawValue = value.replace(/,/g, "");
    let newValue = Number(rawValue);

    if (item.unit === "E" && setPayPoint) {
      if (Number.isNaN(newValue)) {
        newValue = 0;
        setPayPoint(0);
      } else {
        const numberValue = exchangePointToWon(newValue);
        newValue = Number(numberValue);
        setPayPoint(Number(numberValue));
      }
    } else if (item.unit === "RABBIT" && setPaySeed) {
      if (Number.isNaN(newValue)) {
        newValue = 0;
        setPaySeed(0);
      } else {
        const numberValue = newValue * Const.SEED_RATE;
        newValue = Number(numberValue);
        setPaySeed(Number(rawValue));
      }
    }
    item.set(newValue);
  };

  const handlePayAmountBlur = (item: PayTypeDto) => {
    const currentValue = item.value || 0;
    if (currentValue < 0) {
      item.set(0);
      return;
    }
  };

  return (
    <PayTypeWrapper>
      <div className="pay-title">
        {isWide ? (
          `결제방식(${getPaymentText()})`
        ) : (
          <>
            결제방식
            <br />({getPaymentText()})
          </>
        )}
      </div>
      <PayTypeContent isWide={isWide}>
        {payType.map((item, i) => (
          <PayTypeItem
            key={i}
            isWide={isWide}
            $isHover={hover === i}
            onClick={() => handlePayFull?.(i)}
          >
            <div
              className="name"
              onMouseEnter={() => setHover(i)}
              onMouseLeave={() => setHover(-1)}
            >
              {hover === i
                ? `${item.name} 전액`
                : `${item.name}${isWide && item?.unit ? `(${item?.unit})` : ""}`}
            </div>
            <input
              type="text"
              placeholder="금액"
              inputMode="numeric"
              value={
                item.value
                  ? item.unit === "E"
                    ? exchangePoint(item.value)
                    : item.unit === "RABBIT"
                      ? exchangeSeed(item.value)
                      : formatNumber(item.value)
                  : ""
              }
              onBlur={() => handlePayAmountBlur(item)}
              onClick={(e) => e.stopPropagation()}
              onChange={(e) => {
                handlePayAmount(e.target.value, item);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleBuyIn?.();
                }
              }}
            />
          </PayTypeItem>
        ))}
        {setAddStack ? (
          <PayTypeItem isWide={isWide}>
            <div className="name">추가 스택</div>
            <input
              type="text"
              placeholder="추가 스택"
              value={formatNumber(addStack ?? 0)}
              onChange={(e) => {
                const rawValue = e.target.value.replace(/,/g, "");
                setAddStack(+rawValue);
              }}
            />
          </PayTypeItem>
        ) : (
          <></>
        )}
      </PayTypeContent>
    </PayTypeWrapper>
  );
};
